<template>
  <div class="wrapper">
    <div>
      <span>DATOS DE TERMINALES</span>
      <span id="total">Total: {{ count }}</span>
    </div>

    <br />
    <div class="table-container">
      <el-table
        :data="TableData"
        style="width: 100%"
        class="Tabla"
        height="400"
      >
        <el-table-column label="ID" prop="ID" minWidth:150> </el-table-column>

        <el-table-column
          prop="Name"
          label="Descripcion"
          minWidth:150
        ></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    Cliente: String,
    Data: []
  },

  data() {
    return {
      isLoading: false,
      count: 0,
      TableData: []
    };
  },

  methods: {
    async GetData(cliente) {
      let rnc = this.Data.find((element) => element.NumContrato == cliente);
      await this.$http
        .get(`/api/tennos/GetTerminalesByCliente?cliente=${rnc.rnc}`)
        .then(({ data }) => {
          this.TableData = data.Terminales;
          this.count = data.Total;
        });

      this.$emit("TERMINALESDATA", this.TableData);
    }
  },

  watch: {
    async Cliente() {
      if (this.Cliente) {
        await this.GetData(this.Cliente);
      } else {
        this.TableData = [];
      }
    }
  }
};
</script>

<style>
.Table {
  margin: 0 auto;
  padding-left: 200px;
}
.Tabla {
  margin: 0 auto;
  /* padding-left: 200px; */
}
.table-container {
  margin: 0 auto;
}
#total {
  float: right;
}
</style>
